import axios from 'axios'
import { clearStoredAuthSessions, getStoredAuthSessions, suppressToastsAfterLogout } from './authLogout'

// Once a token is rejected by the server (force logout, expired session, another
// device taking over a single-session role, etc.) every screen using that token
// would otherwise keep polling and toasting "Not authorized" forever instead of
// sending the user back to login. This interceptor catches that globally.
let hasRedirected = false

const isLoginPath = (pathname) =>
  pathname.startsWith('/login') || pathname === '/' || pathname.startsWith('/player-login')

export const setupAuthInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status
      const hadAuthHeader = Boolean(error.config?.headers?.Authorization)

      if (status === 401 && hadAuthHeader && !hasRedirected && !isLoginPath(window.location.pathname)) {
        hasRedirected = true

        const { adminInfo } = getStoredAuthSessions()
        const redirectTo = adminInfo?.token ? '/login' : '/player-login'

        const reason = error.response?.data?.message
        if (adminInfo?.token && /session/i.test(reason || '')) {
          try {
            sessionStorage.setItem('authNotice', reason)
          } catch {
            // storage unavailable
          }
        }

        suppressToastsAfterLogout()
        clearStoredAuthSessions()
        window.location.href = redirectTo
      }

      return Promise.reject(error)
    },
  )
}
